import React from "react";
import { motion } from "framer-motion";
import img7a from "../assets/fou1.png";
import ts from "../assets/fou2.png";
import venu from "../assets/fou3.png";
import img8a from "../assets/fou4.png";
import "./SCLprofile.css";
import Footer from "./Footer";

const leaders = [
  {
    img: img7a,
    name: "Shri T. V. Sundaram Iyengar",
    role: "Founder – TVS Group",
    desc: "A pioneer of Indian industry, <b>Shri T. V. Sundaram Iyengar</b> laid the foundation of the <b>TVS Group</b> in 1911 by starting South India’s first organized bus service. His enterprise soon became synonymous with reliability, discipline, and service excellence. Guided by the belief that business must serve society, he diversified into transport, distribution, and manufacturing, building one of India’s earliest professionally managed business groups. His enduring legacy lives on through the Group’s companies — including <b>Sundaram Clayton Limited</b>, which embodies his vision of <i>service through quality and reliability.</i>",
  },
  {
    img: ts,
    name: "Shri T. S. Srinivasan",
    role: "Founder – Sundaram Clayton Limited<br/>Former Chairman – TVS Group",
    desc: "Carrying forward the legacy of the TVS Group, <b>Shri T. S. Srinivasan</b> played a foundational role in establishing <b>Sundaram-Clayton Limited (SCL)</b> in 1962, through a joint venture with <b>Clayton Dewandre Holdings Plc., UK</b>. SCL began its journey in automotive components, manufacturing air-assisted and air-brake systems for commercial vehicles, and subsequently expanded into die casting in 1968. Under his leadership, the company laid the foundations for a strong engineering and manufacturing organisation, building capabilities that enabled SCL to grow into a leading automotive component manufacturer. His contribution formed an important part of the company's early journey, providing the foundation for the culture of quality, engineering excellence, and continuous improvement that evolved at SCL over the decades.",
  },
  {
    img: venu,
    name: "Mr. Venu Srinivasan",
    role: "Chairman - Sundaram Clayton Limited  <br/>Chairman Emeritus - TVS Motor Company",
    desc: "A visionary industrialist and global thought leader, <b>Mr. Venu Srinivasan</b> transformed <b>SCL and TVS Motor Company into</b> internationally recognized organizations renowned for quality, innovation, and sustainability.  He championed the adoption of <b>TQM and Lean manufacturing</b>, earning SCL and TVS Motor the <b>Deming Prize</b>—making them among the first Indian companies to achieve this distinction. Under his guidance, the companies expanded globally, built advanced R&D capabilities, and upheld the Group’s legacy of ethics and community service. His leadership reflects a rare blend of business acumen, technical depth, and social consciousness.",
  },
  {
    img: img8a,
    name: "Dr. Lakshmi Venu",
    role: "Managing Director – Sundaram Clayton Limited",
    desc: "Representing the fourth generation of the founding family, <b>Dr. Lakshmi Venu</b> leads SCL into its next phase of growth—anchored in technology, innovation, and sustainability. With academic grounding in economics and management and rich global exposure, she has driven strategic investments in <b>advanced manufacturing, digital transformation,</b> and <b>electric-mobility solutions</b>. Her focus on collaboration, environmental stewardship, and operational agility has strengthened SCL’s position as a trusted global partner to leading automotive manufacturers. Dr. Venu’s leadership symbolizes the evolving spirit of the TVS legacy—<i>rooted in values, driven by innovation, and inspired by the future.</i>",
  },
];

const SCLprofile = () => {
  return (
    <section id="scl-profile">
      <section className="scl-container">
        <motion.div
          className="scl-header"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h1>A Legacy Built on Vision, Values, and Excellence</h1>
          <p>
            Four generations of leadership driving innovation, quality, and trust
            in mobility
          </p>
        </motion.div>

        <div className="scl">
          {leaders.map((leader, index) => (
            <motion.div
              key={index}
              className="scl-item"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
            >
              <div className="scl-img1">
                <img src={leader.img} alt={leader.name} />
                {/* {index !== leaders.length - 1 && <div className="line"></div>} */}
              </div>
              <div className="scl-content">
                <h3>{leader.name}</h3>
                <h4 dangerouslySetInnerHTML={{ __html: leader.role }}></h4>
                <p dangerouslySetInnerHTML={{ __html: leader.desc }}></p>
              </div>
            </motion.div>
          ))}
        </div>

    
      </section>

      <Footer />
    </section>
  );
};

export default SCLprofile;
